import { render, staticRenderFns } from "./gzhMenuEdit.vue?vue&type=template&id=082c4249&scoped=true&"
import script from "./gzhMenuEdit.vue?vue&type=script&lang=ts&"
export * from "./gzhMenuEdit.vue?vue&type=script&lang=ts&"
import style0 from "./gzhMenuEdit.vue?vue&type=style&index=0&id=082c4249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c4249",
  null
  
)

export default component.exports